<template>
  <b-sidebar
    id="sidebar-manage-apply-document"
    sidebar-class="sidebar-lg"
    bg-variant="white"
    shadow
    backdrop
    no-header
    right
  >
    <template #default="{ hide }">
      <!-- Header -->
      <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
        <h5 class="mb-0">
          {{ $t('Update') }}
        </h5>

        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="clear(hide)"
        />

      </div>
      <!-- Body -->
      <b-form
        class="p-2"
        @submit.prevent
      >
        <validation-observer ref="applyDocumentCreate">
          <!-- Dc Type -->
          <b-form-group
            :label="$t('Dc Type')"
            label-for="dc_type"
          >
            <validation-provider
              #default="{ errors }"
              :name="$t('Dc Type')"
            >
              <v-select
                id="dc_type"
                v-model="applyDocument.dc_type"
                :reduce="(option) => option.id"
                :options="dcTypes"
                :get-option-label="(option) => $langName(option.name)"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>

          <!-- Directions -->
          <b-form-group
            :label="$t('Directions')"
            label-for="direction"
          >
            <validation-provider
              #default="{ errors }"
              :name="$t('Directions')"
            >
              <v-select
                id="direction"
                v-model="applyDocument.direction"
                :reduce="(option) => option.direction.id"
                :options="directions"
                :get-option-label="(option) => option.direction ? option.direction.code + ' - ' + $langName(option.direction.name): null"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>

          <b-form-group
            :label="$t('Participate')"
            label-for="participate"
          >
            <validation-provider
              #default="{ errors }"
              :name="$t('Participate')"
            >
              <b-form-checkbox
                v-model="applyDocument.is_participated_exam"
                value="100"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>

        </validation-observer>
        <!-- Form Actions -->
        <div class="d-flex mt-2">
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="mr-2"
            type="submit"
            @click="submit(hide)"
          >
            {{ applyDocument.id ? $t('Update') : $t('Create') }}
          </b-button>
          <b-button
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            variant="outline-secondary"
            @click="clear(hide)"
          >
            {{ $t('Cancel') }}
          </b-button>
        </div>
      </b-form>
    </template>
  </b-sidebar>
</template>

<script>
import {
  BSidebar, BForm, BFormGroup, BButton, BFormCheckbox,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import { ValidationProvider, ValidationObserver, localize } from 'vee-validate'
import { required } from '@/libs/validations/validations'

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    BSidebar,
    BForm,
    BFormGroup,
    BButton,
    vSelect,
    BFormCheckbox,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      required,
    }
  },
  computed: {
    applyDocument: {
      get() {
        return this.$store.state.applyDocument.applyDocument
      },
      set(data) {
        this.$store.commit('applyDocument/UPDATE', data)
      },
    },
    dcTypes() {
      return this.$store.state.staticModule.dcTypes
    },
    eduLangTypes() {
      return this.$store.state.staticModule.eduLangTypes
    },
    organizations() {
      return this.$store.state.applyDocument.organizations
    },
    directions() {
      return this.$store.state.applyDocument.directions
    },
    activeQuarter() {
      return this.$store.state.staticModule.activeQuarter
    },
  },
  mounted() {
    localize(this.$i18n.locale)
    this.$store.dispatch('staticModule/dcType')
    this.$store.dispatch('staticModule/eduLangTypes')
  },
  methods: {
    loadDirections() {
      if (this.applyDocument.organization) {
        this.$store.dispatch('applyDocument/directions', { org: this.applyDocument.organization, limit: 9999 })
      }
    },
    clear(hide) {
      this.$store.commit('applyDocument/FRESH')
      this.$refs.applyDocumentCreate.reset()
      hide()
    },
    submit(hide) {
      this.$refs.applyDocumentCreate.validate().then(success => {
        if (success) {
          this.$createSwal(this, this.applyDocument, 'applyDocument/manage', () => {
            this.$emit('refetchData')
            this.$store.commit('applyDocument/FRESH')
          })
          hide()
        }
      })
    },
  },
}
</script>
